import { Button, Divider, Input } from 'antd'
import { faCopy } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { IPanelist } from 'interfaces/webinars'
import {
  PanelistName,
  PanelistEmail,
  JoinURL,
  Container,
  CopyButton,
} from './styled'

interface PanelistProps {
  panelist: IPanelist
}

export const PanelistRow = ({ panelist }: PanelistProps) => {
  const { t } = useTranslation()
  const prefix = 'webinars'
  const copyText = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <PanelistName>{panelist.name}</PanelistName>
      <PanelistEmail>{panelist.email}</PanelistEmail>
      <Container>
        <JoinURL>
          <Input placeholder={panelist.joinUrl} value={panelist.joinUrl} />
        </JoinURL>
        <CopyButton>
          <Button type="link" onClick={() => copyText(panelist.joinUrl)}>
            <FontAwesomeIcon style={{ paddingRight: '8px' }} icon={faCopy} />
            {t(`${prefix}.modal.table.btnCopyUrl`)}
          </Button>
        </CopyButton>
      </Container>
      <Divider />
    </>
  )
}
